import React, {
    Component
} from 'react';


class CssPaginator extends Component {
    constructor(props) {
        super(props);

        this.page = 1;
        this.entries = null;
        this.paginationNumber = null;
    }

    componentDidMount() {
        this.entries = this.props.proxy.querySelectorAll('.entry');
        this.paginationNumber = parseInt(this.props.pagination);
        this.initPaginator();
        this.partiallyHideEntries();

        let moreCta = this.props.proxy.querySelector('.more');

        moreCta.addEventListener('click', () => {
            this.showEntries();
        });
    }

    initPaginator() {
        if (this.entries.length <=(this.page * this.paginationNumber)) {
            this.hideCta()
        }
    }

    initPaginatorModulo() {
        if (this.entries.length > this.paginationNumber) {
            let toHide;
            if (this.entries.length % this.paginationNumber == 0) {
                toHide = this.entries.length / 2;
            }
            else {
                toHide = this.entries.length % this.paginationNumber
                this.hideCta();
            }
            this.partiallyHideEntries(toHide);
        }
        else {
            this.hideCta()
        }
    }

    partiallyHideEntries() {
        let start = this.page * this.paginationNumber;
        Array.from(this.entries).slice(start, this.entries.length).map((entry) => {
            entry.classList.add("hide");
        });

    }

    showEntries() {
        let start = (this.page) * this.paginationNumber;
        Array.from(this.entries).slice(start, start+this.paginationNumber).map((entry) => {
            entry.classList.remove("hide");
        });
        this.page++;
        this.initPaginator();
    }

    hideCta() {
        this.props.proxy.querySelector('.more').classList.add('hide');
    }

    render() {
        return <div>

        </div>
    }
}

export default CssPaginator


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/CssPaginator.js